import { render, staticRenderFns } from "./ProductsAndPricesView.vue?vue&type=template&id=f0161412"
import script from "./ProductsAndPricesView.vue?vue&type=script&lang=js"
export * from "./ProductsAndPricesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports